import * as React from "react";
import "./Dashboard.css";
import "../../Assets/CSS/bulkorder.css";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { removeToken } from "../../redux/tokenSlice";
import authService from "../../services/auth.service";
import { useSelector, useDispatch } from "react-redux";
import Avatar from "@mui/material/Avatar";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { NavBar } from "../Navbar/NavBar";
import { useState } from "react";
import { useEffect } from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import moment from "moment";
import { List1 } from "./List1";
import Form from "react-bootstrap/Form";
import Loader from "../Loader";
import Sidebar from "../Sidebar";

export default function Dashboard() {
  const history = useNavigate();
  const handleDelete = (chipToDelete) => () => {
    // setChipData((chips) =>
    //   chips.filter((chip) => chip.key !== chipToDelete.key)
    // );
  };
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [batchesData, setBatchesData] = useState({});
  const [loading, setLoading] = useState(false);

  // ------------------API Calls-------------------------------
  const getBatches = () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    let data = fetch("/workflow/api/bulk/batches?start=0&length=500", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.status === true) {
          setBatchesData(res?.batches);
          setLoading(false);
        } else {
          setBatchesData({ rows: [] });
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    if (userDetails?.user_category === "Finance") getBatches();
  }, []);

  return (
    <div className="flex">
      <div className="container-fluid builk-main ">
        <Loader loading={loading} />
        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col-12 d-flex justify-content-between">
              <span className="fs-5 font-semibold">Pre- Order List</span>
              {userDetails?.email_address === "operations@ayekart.com" ? (
                <button
                  className="btn btn-primary border pl-4 pr-4 fs-5 pt-1 pb-1 bg-0C3094 text-light text-font"
                  onClick={() => history("/pre-order-list/Upload")}
                >
                  <FileUploadIcon className="mr-2" />
                  Upload
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        {userDetails?.user_category === "Finance" ? (
          <div className="mx-0 mt-3">
            <div class="order-list-container  ">
              <div className="list-table overflow-auto mt-2">
                <table class="table">
                  <thead
                    class="thead-dark header"
                    style={{ backgroundColor: "#00213e" }}
                  >
                    <tr>
                      <th class="header" scope="col">
                        Uploaded Date
                      </th>
                      <th class="header" scope="col">
                        Batch No
                      </th>
                      <th class="header" scope="col">
                        No of Orders
                      </th>
                      <th class="header" scope="col">
                        Total CP
                      </th>
                      <th class="header" scope="col">
                        Total SP
                      </th>
                      <th class="header" scope="col">
                        Level 1
                      </th>
                      <th class="header" scope="col">
                        Level 2
                      </th>
                      <th class="header" scope="col">
                        Level 3
                      </th>
                      <th class="header" scope="col">
                        Tags
                      </th>
                      <th class="header" scope="col">
                        View
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {batchesData && batchesData?.rows?.length > 0 ? (
                      batchesData?.rows?.map((item, index) => (
                        <tr className="list-table-row" key={index}>
                          <td>
                            {moment(item?.updated_at).format("DD/MM/yyyy")}
                          </td>
                          <td>{item?.id}</td>
                          <td>{item?.total_orders}</td>
                          <td>{item?.total_cp}</td>
                          <td>{item?.total_sp}</td>
                          <td className="fw-bold text-success">
                            <small>{item?.level_1_status}</small>
                          </td>
                          <td className="fw-bold text-warning">
                            <small>{item?.level_2_status}</small>
                          </td>
                          <td className="   ">
                            <small>{item?.level_3_status}</small>
                            <br />
                          </td>
                          <td>{item?.tag}</td>
                          <td className="text-center text-primary">
                            <KeyboardArrowRightIcon
                              role="button"
                              onClick={() =>
                                history(`/pre-order-list/Batch/${item?.id}`, {
                                  state: item?.id,
                                })
                              }
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <h5>No Records Found</h5>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <Toaster />
          </div>
        ) : (
          <List1 />
        )}
      </div>
    </div>
  );
}
